import { render, staticRenderFns } from "./TrustpilotCarousel.vue?vue&type=template&id=68227882&scoped=true&"
import script from "./TrustpilotCarousel.vue?vue&type=script&lang=js&"
export * from "./TrustpilotCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TrustpilotCarousel.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./TrustpilotCarousel.vue?vue&type=style&index=1&id=68227882&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "68227882",
  null
  
)

export default component.exports